/**
 * App Store
 *
 * Global application state store using Zustand.
 */

import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

type Theme = 'light' | 'dark' | 'system';

interface AppState {
  theme: Theme;
  sidebarOpen: boolean;
}

interface AppActions {
  setTheme: (theme: Theme) => void;
  toggleSidebar: () => void;
  setSidebarOpen: (open: boolean) => void;
}

type AppStore = AppState & AppActions;

export const useAppStore = create<AppStore>()(
  devtools(
    persist(
      (set) => ({
        // State
        theme: 'system',
        sidebarOpen: true,

        // Actions
        setTheme: (theme) => set({ theme }, false, 'setTheme'),
        toggleSidebar: () =>
          set((state) => ({ sidebarOpen: !state.sidebarOpen }), false, 'toggleSidebar'),
        setSidebarOpen: (sidebarOpen) => set({ sidebarOpen }, false, 'setSidebarOpen'),
      }),
      {
        name: 'app-storage',
        partialize: (state) => ({ theme: state.theme }),
      }
    ),
    { name: 'AppStore' }
  )
);

// Selectors
export const selectTheme = (state: AppStore) => state.theme;
export const selectSidebarOpen = (state: AppStore) => state.sidebarOpen;

export default useAppStore;
